import React from "react";
import { useQuery } from "@apollo/react-hooks";
import { gql } from "apollo-boost";
import { Loader } from "./StyledComponents";

export function ByobBase({
  selected,
  setSelected,
  type = false,
  display_component,
}) {
  const { loading, error, data } = useQuery(
    gql`
      query bedType($slug: String!) {
        bedType(slug: $slug) {
          id
          title
          slug
        }
      }
    `,
    { variables: { slug: selected.bed.main_slug } }
  );
  if (loading) return <Loader />;
  if (error) {
    console.warn("Failed to fetch, trying again");
    //refetch()
    return <p>Error :(</p>;
  }
  const { bedType } = data;
  const Selections = display_component;
  const nullable = ["headboards", "bedsidetable", "ottoman"];
  const handleClick = (title) => {
    const newSelect = { ...selected };
    if (
      newSelect[type] &&
      typeof newSelect[type] === "object" &&
      title.id === newSelect[type].id &&
      nullable.indexOf(type) > -1
    ) {
      newSelect[type] = null;
    } else {
      newSelect[type] = title;
    }
    setSelected(newSelect);
  };
  if (type) {
    return (
      <Selections {...bedType} handleClick={handleClick} selected={selected} />
    );
  }
  return <NoMatch type={type} />;
}

export const NoMatch = ({ type = null }) => (
  <div>{type && <h1>Kunde inte hitta {type}</h1>}</div>
);
